module.exports = __webpack_public_path__ + "static/8-2ae1d83037bf18a33b4bb3d760985bf9.jpg";